"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentSession = void 0;

var PaymentCommunicator_1 = require("./PaymentCommunicator");

var interface_adapter_1 = require("../Interfaces/interface.adapter");

var Interfaces_1 = require("../Interfaces");

var Adapters_1 = require("../Adapters");

var Configs_1 = require("../Configs");

var Errors_1 = require("../Errors");

var EcheckAdapter_1 = require("../Adapters/EcheckAdapter");

var PaymentSession =
/** @class */
function () {
  function PaymentSession(session) {
    this.env = session.env;
    this.paymentCommunicator = new PaymentCommunicator_1.PaymentCommunicator(session);
  }

  PaymentSession.prototype.getSessionInfo = function (billingContact) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = this;
            return [4
            /*yield*/
            , this.paymentCommunicator.getVendorSessionInfo()];

          case 1:
            _a.vendorSessionInfo = _c.sent();
            _b = this;
            return [4
            /*yield*/
            , this.getVendorAdaptor(this.vendorSessionInfo, billingContact)];

          case 2:
            _b.adapter = _c.sent();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentSession.prototype.setSessionInfo = function (vendorSessionInfo, billingContact) {
    return __awaiter(this, void 0, void 0, function () {
      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.vendorSessionInfo = vendorSessionInfo;
            _a = this;
            return [4
            /*yield*/
            , this.getVendorAdaptor(this.vendorSessionInfo, billingContact)];

          case 1:
            _a.adapter = _b.sent();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentSession.prototype.getVendorAdaptor = function (vendorSessionInfo, billingContact) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (vendorSessionInfo.vendorName) {
          case interface_adapter_1.PaymentVendors.dummy:
            return [2
            /*return*/
            , new Adapters_1.PaymentAdapterDummy(this.env, vendorSessionInfo, billingContact)];

          case interface_adapter_1.PaymentVendors.adyen:
            return [2
            /*return*/
            , new Adapters_1.PaymentAdapterAdyen(this.env, vendorSessionInfo, billingContact)];

          case interface_adapter_1.PaymentVendors.ingenico:
            return [2
            /*return*/
            , new Adapters_1.PaymentAdapterIngenico(this.env, vendorSessionInfo, billingContact)];

          case interface_adapter_1.PaymentVendors.inicis:
            return [2
            /*return*/
            , new Adapters_1.PaymentAdapterInicis(this.env, vendorSessionInfo, billingContact)];

          case interface_adapter_1.PaymentVendors.safetypay:
            return [2
            /*return*/
            , new Adapters_1.PaymentAdapterSafetyPay(this.env, vendorSessionInfo, billingContact)];

          case interface_adapter_1.PaymentVendors.echeck:
            return [2
            /*return*/
            , new EcheckAdapter_1.EcheckAdapter(this.env, vendorSessionInfo, billingContact)];

          default:
            throw new Errors_1.PaymentClientError('Cannot determine vendor adaptor', Interfaces_1.PaymentErrorShortCodes.adapter_determination_error);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentSession.prototype.encryptCreditCardData = function (creditCard) {
    return __awaiter(this, void 0, void 0, function () {
      var encryptedCard, e_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , new Promise(function (resolve, reject) {
              if (!_this.adapter) {
                reject('Cannot determine vendor adaptor');
              } else {
                // eslint-disable-next-line prefer-const
                var timeoutId_1;

                _this.adapter.encryptCreditCardData(creditCard).then(function (encryptedCardData) {
                  clearTimeout(timeoutId_1);
                  resolve(encryptedCardData);
                })["catch"](function (e) {
                  clearTimeout(timeoutId_1);
                  reject(e);
                });

                timeoutId_1 = setTimeout(function () {
                  reject('timeout');
                }, Configs_1.Config.defaultVendorTimeout);
              }
            })];

          case 1:
            encryptedCard = _a.sent();
            return [3
            /*break*/
            , 3];

          case 2:
            e_1 = _a.sent();

            if (e_1 instanceof Errors_1.PaymentClientError) {
              throw e_1;
            }

            throw new Errors_1.PaymentTimeoutError('Payment time-out while waiting for vendor response');

          case 3:
            this.encryptedPaymentData = encryptedCard;
            return [2
            /*return*/
            , encryptedCard];
        }
      });
    });
  };

  PaymentSession.prototype.encryptACHData = function (achInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var encryptedACHData, e_2;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , new Promise(function (resolve, reject) {
              if (!_this.adapter) {
                reject('Cannot determine vendor adaptor');
              } else {
                // eslint-disable-next-line prefer-const
                var timeoutId_2;

                _this.adapter.encryptACHData(achInfo).then(function (encryptedData) {
                  clearTimeout(timeoutId_2);
                  resolve(encryptedData);
                })["catch"](function (e) {
                  clearTimeout(timeoutId_2);
                  reject(e);
                });

                timeoutId_2 = setTimeout(function () {
                  reject('timeout');
                }, Configs_1.Config.defaultVendorTimeout);
              }
            })];

          case 1:
            encryptedACHData = _a.sent();
            return [3
            /*break*/
            , 3];

          case 2:
            e_2 = _a.sent();

            if (e_2 instanceof Errors_1.PaymentClientError) {
              throw e_2;
            }

            throw new Errors_1.PaymentTimeoutError('Payment time-out while waiting for vendor response');

          case 3:
            this.encryptedPaymentData = encryptedACHData;
            return [2
            /*return*/
            , encryptedACHData];
        }
      });
    });
  };

  PaymentSession.prototype.encryptEcheckData = function (echeckInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        // for the moment, we send check data plaintext
        // note that THIS IS PCI COMPLIANT but not best practice
        // at a later time, we will add functionality to encrypt the data with the vendor
        return [2
        /*return*/
        , Promise.resolve(JSON.stringify(echeckInfo))];
      });
    });
  };

  PaymentSession.prototype.initializeWebDropIn = function (divId, paymentMethods, paymentCommunicator, // invoked when component button is clicked to initiate the first step of the charge (tokenization intent)
  onStatus, // get status from final stage
  onError // get any errors back in this callback
  ) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.adapter) {
              throw new Errors_1.PaymentClientError('Cannot determine vendor adaptor', Interfaces_1.PaymentErrorShortCodes.adapter_determination_error);
            }

            return [4
            /*yield*/
            , this.adapter.initializeWebDropIn(divId, paymentMethods, paymentCommunicator, onStatus, onError)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentSession.prototype.initializeWebComponent = function (divId, paymentMethod, paymentCommunicator, // invoked when component button is clicked to initiate the first step of the charge (tokenization intent)
  onStatus, // get status from final stage
  onError // get any errors back in this callback
  ) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.adapter) {
              throw new Errors_1.PaymentClientError('Cannot determine vendor adaptor', Interfaces_1.PaymentErrorShortCodes.adapter_determination_error);
            }

            return [4
            /*yield*/
            , this.adapter.initializeWebComponent(divId, paymentMethod, paymentCommunicator, onStatus, onError)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentSession.prototype.processPayment = function (encryptedData, paymentMethod, billingContact) {
    return __awaiter(this, void 0, void 0, function () {
      var responseBody, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.paymentCommunicator.processPayment(encryptedData, paymentMethod, billingContact)];

          case 1:
            responseBody = _a.sent();
            response = {
              billingToken: responseBody.billingToken
            };

            if (responseBody.authId) {
              response.authId = responseBody.authId;
            }

            if (responseBody.paymentId) {
              response.paymentId = responseBody.paymentId;
            }

            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  PaymentSession.prototype.completePaymentSession = function (authId, isDefaultPaymentMethod) {
    return __awaiter(this, void 0, void 0, function () {
      var responseBody, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.paymentCommunicator.completePaymentSession(authId, isDefaultPaymentMethod)];

          case 1:
            responseBody = _a.sent();
            response = {
              paymentId: responseBody.paymentId
            };
            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  return PaymentSession;
}();

exports.PaymentSession = PaymentSession;